import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from 'react';
import { verifyRole, useCurrentUser } from '@applyboard/ui-utils';
import { CheckEligibilityFlowModal } from "../../";
import { DSJ_ELIGIBILITY_RESULTS_HASH } from "../CEF/Common/Constants";
import { removeHashFromURL } from "../CEF/Utilities/RedirectTools";
export function SimplifiedCheckEligibilityModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    programId = _ref.programId,
    setDsjState = _ref.setDsjState,
    exploreAction = _ref.exploreAction,
    ineligibleRegisterRedirect = _ref.ineligibleRegisterRedirect,
    openModal = _ref.openModal;
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var userRole = currentUser === null || currentUser === void 0 ? void 0 : currentUser.role;
  useEffect(function () {
    if (openModal && window.location.hash === DSJ_ELIGIBILITY_RESULTS_HASH) {
      openModal();
      //remove hash from the url
      removeHashFromURL();
    }
  }, [openModal]);
  return verifyRole.isStudent(currentUser) || verifyRole.isVisitor(currentUser) ? /*#__PURE__*/React.createElement(CheckEligibilityFlowModal, {
    onClose: onClose,
    open: open,
    programId: programId,
    userRole: userRole,
    userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
    onSave: setDsjState,
    exploreAction: exploreAction,
    ineligibleRegisterRedirect: ineligibleRegisterRedirect
  }) : null;
}